const THEME_KEY = 'planning-poker:theme';
const NAME_KEY = 'planning-poker:displayName';

export type Theme = 'dark' | 'light';

export const LocalStorageService = {
  getTheme(): Theme {
    return (localStorage.getItem(THEME_KEY) as Theme) || 'dark';
  },
  setTheme(theme: Theme): void {
    localStorage.setItem(THEME_KEY, theme);
  },
  getDisplayName(): string | null {
    return localStorage.getItem(NAME_KEY);
  },
  setDisplayName(name: string): void {
    localStorage.setItem(NAME_KEY, name);
  },
};
